import axios from '@/components/api/axios';

async function getPaymentMethodList() {
  const res = await axios.axiosGet('/api/purchases/getPaymentMethodList', null);
  return res;
}

async function getCouponList(itemData) {
  const res = await axios.axiosPost('/api/purchases/getCouponList', itemData);
  return res;
}

async function confirmOrder(orderData) {
  const res = await axios.axiosPost('/api/purchases/confirmOrder', orderData);
  console.log('confirmOrder');
  if(!res) {
    return res;
    return 'error';
  }
  return res;
}

async function createOrder(orderData) {
  const res = await axios.axiosPost('/api/purchases/createOrder', orderData);
  console.log('createOrder');
  if(!res) {
    return 'error';
  }
  return res;
}

export default {
  getPaymentMethodList,
  getCouponList,
  confirmOrder,
  createOrder
}



// WEBPACK FOOTER //
// ./src/components/api/purchases.js